// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles_iconWrapper__3kTby","iconText":"styles_iconText__150Az"};